import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const sale = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z
      .string()
      .describe(
        'Sale name or code, e.g. "KF24" or "Keeneland September 2024".',
      ),

    startDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('First session day of the sale.'),

    endDate: z
      .string()
      .nullable()
      .optional()
      .presentAs('date')
      .describe('Last session day of the sale.'),

    salePhotos: hasMany('SalePhoto'),
  })
  .describe(
    'A horse auction whose catalog photos are measured — for example "KF24"\n(Keeneland Foals 2024). A sale runs across many days and catalogs the sale\nphotos uploaded under it.',
  )
  .as('Sale');

export { sale as saleSchema };
